import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom';

const SubNav = (props) => {
    const [isDropdown, setIsDropdown] = useState(false);
    const menuRef = useRef();
    const { isShow, setIsShow } = props;

    useEffect(() => {
        document.addEventListener('mousedown', (e) => {
            if (!menuRef.current.contains(e.target)) {
                setIsDropdown(false)
            }
        })
    }, [isDropdown])

    return (

        <header ref={menuRef} className="sticky top-0 z-30">
            <nav className='bg-cyan-600 h-14 w-full flex justify-between items-center relative  z-30
            '>
                <i className="fa-solid fa-bars text-white text-2xl cursor-pointer pl-6" onClick={() => setIsShow(!isShow)}></i>
                <div className='bg-cyan-700 h-full grid place-content-center cursor-pointer text-base hover:bg-cyan-800 animation' onClick={() => setIsDropdown(!isDropdown)} >
                    <p className='px-3 md:px-8 text-white font-medium tracking-wide'>Welcome:-Grow Up Fitness<i className={`fa-solid fa-angle-down ${isDropdown ? "rotate-180 " : ""} ml-2 animation`}></i></p>
                </div>
            </nav>
            <ul className={`absolute right-0 z-10 ${isDropdown ? "top-14" : "-top-[500%]"} bg-cyan-600 shadow-xl shadow-slate-500 rounded-b-xl animation `} >
                <li className='dropdown_li group'>
                    <Link to="/ProfileDetails" className='dropdown_a'>
                        <i className="fa-regular fa-user group-hover:text-teal-500"></i>
                        <span className='group-hover:text-slate-600 ml-2'>My Profile</span>
                    </Link>
                </li>

                <li className='dropdown_li group'>
                    <Link to="/admin/termsconditions" className='dropdown_a'>
                        <i className="fa-solid fa-file-circle-check group-hover:text-teal-500"></i>
                        <span className='group-hover:text-slate-600 ml-2'>Membership Agreement</span>
                    </Link>
                </li>

                <li className='dropdown_li group'>
                    <Link to="/MemberManage" className='dropdown_a'>
                        <i className="fa-solid fa-user-plus group-hover:text-teal-500"></i>
                        <span className='group-hover:text-slate-600 ml-2'>My Membership</span>
                    </Link>
                </li>

                {/* <li className='dropdown_li group'>
                    <Link to="/Admin/Template" className='dropdown_a'>
                        <i className="fa-solid fa-paper-plane group-hover:text-teal-500"></i>
                        <span className='group-hover:text-slate-600 ml-2'>SMS Template</span>
                    </Link>
                </li> */}

                <li className='dropdown_li group'>
                    <Link to="/Admin/ChangePassword" className='dropdown_a'>
                        <i className="fa-solid fa-lock group-hover:text-teal-500"></i>
                        <span className='group-hover:text-slate-600 ml-2'>Change Password</span>
                    </Link>
                </li>

                <li className='dropdown_li group rounded-b-xl'>

                    <a href='https://elgoog.im/thanos/' target='_blank' className='dropdown_a'>
                        <i className="fa-solid fa-power-off group-hover:text-teal-500"></i>
                        <span className='group-hover:text-slate-600 ml-2'>Logout</span>
                    </a>

                </li>

            </ul>

        </header>

    )
}

export default SubNav;

